import { logOutUser } from "../../../http"
import { wordpressBaseUrl } from "../../../wordpressApiConfig/wordpressApiConfig";
import { persister } from "../../../Redux/store";

export const LogOutAction = async (id: string, dispatch: any) => {
    const wpBaseUrl = wordpressBaseUrl();
    try {
        logOutUser();
        sessionStorage.removeItem("lastVisitedPage")
        // Clear explicit localStorage PII/PHI keys
        localStorage.removeItem("beneficiariesData")
        localStorage.removeItem("userData")
        localStorage.removeItem("pwaBen")
        localStorage.removeItem("sasToken")
        // Purge redux-persist state — clears persist:MainData from localStorage
        // (subscriber, beneficiary, user, subscription slices all contain PII/PHI)
        await persister.purge();
        window.location.href = `${wpBaseUrl}/home/`;
    } catch (e: any) {
        console.log(e)
        throw e
    }
}
